<div class="engine-wrapper">
  <canvas #rendererCanvas id="renderCanvas"></canvas>
</div>
